import api from './client'

// Reseñas de clientes (/clientes/resenas): LA LECTURA de cómo se está
// atendiendo a la gente — una encuesta por vez, con todos adentro.
export const resenasApi = {
  lectura: (params) => api.get('/resenas/lectura', { params }),
  ubicacion: (id) => api.get(`/resenas/${id}/ubicacion`),
  pendientes: () => api.get('/resenas/pendientes'),
  atender: (id, nota) => api.post(`/resenas/${id}/atender`, { nota }),
  // Reseñas de PRODUCTOS (mail de los 15 días, /clientes/resenas-productos)
  productos: (params) => api.get('/resenas-productos', { params }),
  publicarProducto: (id) => api.post(`/resenas-productos/${id}/publicar`),
  ocultarProducto: (id) => api.post(`/resenas-productos/${id}/ocultar`),
}
